import React, { Component } from 'react'
import { Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from "@mui/material";
import { Col, Container, Row, Form, Modal } from 'react-bootstrap';
import axios from "axios";
import Select from '../../../Components/PCSelect';
import WeekRangeSelect from '../../../Components/WeekRangeSelect';
import Swal from "sweetalert2";
import { formatDisplayWeek, formatDisplayDate, sumMoney, getWeekDetails, getWeekDayList, money, approvalActions, hasAction, isSuperAdmin, formatAmount } from '../../../helper';
import PhoneClinicGrid from '../../../Components/PhoneClinicGrid';
import RowActions from '../../../Components/PhoneClinicGrid/RowActions';
import { CARD as PC_CARD, COL_HEAD, INPUT } from '../shared/txStyles';
import StatusChip from '../shared/StatusChip';
import BulkActionBar from '../../../Components/PhoneClinicGrid/BulkActionBar';
import { runTransition, postTransition, reportTransition, APPROVAL_MODULES } from '../shared/approvalApi';

import AmountInput from '../../../Components/AmountInput';
import PageHeader from '../shared/PageHeader';
/* Unified card = shared token + this page's layout extras. */
const CARD = { ...PC_CARD, overflow: 'hidden', marginBottom: 24 };

export default class WeeklySale extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addWeekSale: false,
            isEdit: false,
            WeekSaleList: [],
            ShopList: [],
            WS_ID: "",
            WeeklyShop: "",
            SaleWeek: "",
            WeekDays: [],
            AllShopData: [],
            ExtraShopExpenses: [],
            PC_WS_STATUS: "PENDING",
            // Only whether to RENDER the bulk actions. Every transition is re-checked
            // server-side against pc_role_rights from the signed token.
            canApprove: hasAction('/admin/weekly-sale', 'APPROVE'),
            selectedIds: [],
            bulkBusy: false,
            showModal: false,
            showDelModal: false,
            showFromModal: false,
            payAccDetails: [],
            DeliveryDetails: [],
            fromDetails: [],
            PC_GRP_ID: localStorage.getItem('PC_GRP_ID'),
            PC_SHOP_ID: localStorage.getItem('PC_GRP_ATT'),
            isShopDisable: false,
        };
        this.gridRef = React.createRef(null);
    }

    async getWeeklySale(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true);
        const formData = {
            PC_GRP_ID: this.state.PC_GRP_ID,
            PC_SHOP_ID: this.state.PC_SHOP_ID,
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };

        const getAllSale = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Finance/PCGetAllWeeklySale.php`, formData);
        const WeeklySaleData = getAllSale.data;
        let WeekSaleList = [];
        if (WeeklySaleData.success === 1) {
            WeekSaleList = WeeklySaleData.data;
            pagination.totalItems = parseInt(WeeklySaleData.Page_count[0]['TOTAL_PAGE_COUNT']);
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50);
            this.gridRef.current?.setPaginationData(pagination);
        }
        this.setState({ WeekSaleList });
        this.props.toggleLoader(false);
    }

    async hanldeAddWeekSale() {
        const result = await this.getShopList();
        let isShopDisable = false;
        let WeeklyShop = "", SaleWeek = "", WeekDays = [];

        if (result?.data) {
            const weekResult = await this.getWeekNumberFormatted();
            WeekDays = weekResult.WeekDays;
            SaleWeek = weekResult.WeekNumber;
            const filterResult = result.data.filter(x => String(x.PC_SP_ID) === String(this.state.PC_SHOP_ID));
            if (filterResult.length > 0) {
                isShopDisable = true;
                WeeklyShop = { value: filterResult[0].PC_SP_ID, label: filterResult[0].SP_NAME, type: "shop" };
            }
        }
        this.setState({ addWeekSale: true, isShopDisable, WeeklyShop, SaleWeek, WeekDays });
    }

    async getShopList() {
        this.props.toggleLoader(true);
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        const shopData = getShops.data;
        let result = {};
        let ShopList = [];
        if (shopData.success === 1) {
            ShopList = shopData.data
                .filter(shop => String(this.state.PC_SHOP_ID) !== String(shop.PC_SP_ID))
                .map(shop => ({ value: shop.PC_SP_ID, label: shop.SP_NAME, type: "shop" }));
            result.data = shopData.data;
        }
        this.setState({ ShopList, AllShopData: shopData.data });
        this.props.toggleLoader(false);
        return result;
    }

    // Current week plus its blank day rows. The week comes from getWeekDetails() so it is the
    // real ISO week — the old inline Math.ceil((days + 1) / 7) count ran a week behind and
    // preselected a week the dropdown does not list.
    async getWeekNumberFormatted() {
        const WeekNumber = getWeekDetails().weekId;
        const WeekOut = await getWeekDayList(WeekNumber);
        const WeekDays = WeekOut.map(WeekPerDay => ({
            DateAndDay: WeekPerDay,
            Card: 0,
            Cash: 0,
            Others: 0
        }));

        return { WeekDays, WeekNumber };
    }

    /* Everything the edit form shows for one saved week, from the same three endpoints.
     *
     * Shared by the form (handleUpdateSale) and bulk approve (bulkApprove) on purpose: the profit a
     * bulk approval posts the partner shares from must be computed by exactly the code the form
     * uses, or the two would drift. Until 2026-10-22 this lived inside handleUpdateSale, and bulk
     * approve was switched off, because a list row carries no expenses and the stored WS_PRO_LOS is
     * written only at approval — blank for weeks never approved (61 of 113 awaiting approval) and
     * stale for reopened ones (#341 was £403.00 out). Body moved here unchanged. */
    async loadWeekData(item) {
        const WeeklySaleData = await axios.post(
            `${process.env.REACT_APP_BASE_URL}services/query/Finance/WeeklySale.php`,
            { PC_WS_ID: item.PC_WS_ID, PC_WS_SHOPID: item.PC_WS_SHOPID }
        );

        let WeekDays = [], ExtraShopExpenses = [], DeliveryDetails = [], fromDetails = [];

        if (WeeklySaleData.data.details?.length > 0) {
            WeekDays = WeeklySaleData.data.details.map(eachData => ({
                DateAndDay: eachData.sale_date,
                Cash: eachData.cash_amount,
                Card: eachData.card_amount,
                Others: eachData.other_amount
            }));
        }

        if (WeeklySaleData.data.shop?.length > 0) {
            const shopData = WeeklySaleData.data.shop[0];
            ExtraShopExpenses.push(
                { description: "Rent Charges", amount: money(shopData.SP_RENT_CHARGES), isDisabled: true },
                { description: "K & N Charges", amount: money(shopData.SP_KN_CHARGES), isDisabled: true },
                { description: "NDR Charges", amount: money(shopData.SP_NDR_CHARGES), isDisabled: true }
            );
        }

        const [getAllExpenseOfWH, getWeekShopPayment] = await Promise.all([
            this.getAllExpense(item.PC_WS_WEEK, item.PC_WS_SHOPID),
            this.getWeekShopPayment(item.PC_WS_WEEK, item.PC_WS_SHOPID)
        ]);

        if (getAllExpenseOfWH.details?.length > 0) {
            const totalAmount = sumMoney(getAllExpenseOfWH.details, "BD_AMT");
            ExtraShopExpenses.push({ description: "Delivery", amount: money(totalAmount), isDisabled: true });
        }
        DeliveryDetails = getAllExpenseOfWH.details || [];

        // Account-payment "From" entries (Case 1): expense for this shop's weekly sale. Does not
        // affect the shop's CW Account / shop-payment balance.
        if (getAllExpenseOfWH.dataFrom?.length > 0 && Number(getAllExpenseOfWH.dataFrom[0].TR_AMT) > 0) {
            ExtraShopExpenses.push({
                description: "Account Payment (From)",
                amount: money(getAllExpenseOfWH.dataFrom[0].TR_AMT),
                isDisabled: true
            });
        }
        fromDetails = getAllExpenseOfWH.dataFromDetail || [];

        if (getWeekShopPayment.data.data?.length > 0) {
            getWeekShopPayment.data.data.forEach(shopDet => {
                ExtraShopExpenses.push({
                    description: shopDet.description,
                    amount: money(shopDet.amount),
                    isDisabled: true
                });
            });
        }

        return { WeekDays, ExtraShopExpenses, DeliveryDetails, fromDetails };
    }

    async handleUpdateSale(item) {
        try {
            const { WeekDays, ExtraShopExpenses, DeliveryDetails, fromDetails } = await this.loadWeekData(item);

            const WeeklyShop = { value: item.PC_WS_SHOPID, label: item.SP_NAME, type: "shop" };

            this.setState({
                DeliveryDetails,
                fromDetails,
                ExtraShopExpenses,
                isEdit: true,
                isShopDisable: true,
                addWeekSale: true,
                WS_ID: item.PC_WS_ID,
                SaleWeek: item.PC_WS_WEEK,
                PC_WS_STATUS: item.PC_WS_STATUS,
                WeeklyShop,
                WeekDays
            });
        } catch (error) {
            console.error('handleUpdateSale error:', error);
            Swal.fire('Error', 'Failed to load sale data', 'error');
        }
    }

    async handleChange(fieldName, evt) {
        let value;
        switch (fieldName) {
            case 'WeeklyShop':
                value = evt;
                break;
            case 'SaleWeek': {
                value = evt.target.value;
                const WeekOut = await getWeekDayList(value);
                const WeekDays = WeekOut.map(WeekPerDay => ({
                    DateAndDay: WeekPerDay,
                    Card: 0,
                    Cash: 0,
                    Others: 0
                }));
                this.setState({ WeekDays });
                break;
            }
            default:
                value = evt.target.value;
                break;
        }
        this.setState({ [fieldName]: value });
    }

    ValidateSale() {
        if (!this.state.SaleWeek) {
            Swal.fire('Error', 'Please Select Sale Week', 'error');
            return false;
        }
        if (!this.state.WeeklyShop) {
            Swal.fire('Error', 'Please Select Shop', 'error');
            return false;
        }
        return true;
    }

    async getAllShopExpense(SALEWEEK, SHOPID) {
        const AllShopData = await this.getShopList() || {};
        const formData = { SALEWEEK, SHOPID };

        let ExtraShopExpenses = [];
        let PayByAccountDetails = [];
        let DeliveryDetails = [];

        const filterShopData = AllShopData?.data?.filter(x => +x.PC_SP_ID === +SHOPID);
        if (filterShopData?.length > 0) {
            ExtraShopExpenses.push(
                { description: "Rent Charges", amount: money(filterShopData[0].SP_RENT_CHARGES), isDisabled: true },
                { description: "K & N Charges", amount: money(filterShopData[0].SP_KN_CHARGES), isDisabled: true },
                { description: "NDR Charges", amount: money(filterShopData[0].SP_NDR_CHARGES), isDisabled: true }
            );
        }

        const getAllPayAccounts = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Finance/GetWeeklySaleDelivery.php`, formData);
        const shopData = getAllPayAccounts.data;

        if (shopData.dataA?.length > 0) {
            ExtraShopExpenses.push({
                description: "Pay By Account",
                amount: money(shopData.dataA[0].TR_AMT),
                isDisabled: true
            });
        }

        if (shopData.dataB?.length > 0) PayByAccountDetails = shopData.dataB;

        if (shopData.dataAA?.length > 0) {
            ExtraShopExpenses.push({
                description: "Delivery",
                amount: money(shopData.dataAA[0].BD_AMT),
                isDisabled: true
            });
        }

        // Account-payment "From" entries (Case 1): expense for this shop's weekly sale. Does not
        // affect the shop's CW Account / shop-payment balance.
        if (shopData.dataFrom?.length > 0 && Number(shopData.dataFrom[0].TR_AMT) > 0) {
            ExtraShopExpenses.push({
                description: "Account Payment (From)",
                amount: money(shopData.dataFrom[0].TR_AMT),
                isDisabled: true
            });
        }

        if (shopData.data?.length > 0) DeliveryDetails = shopData.data;

        if (shopData.dataD?.length > 0) {
            shopData.dataD.forEach(shopDet => {
                ExtraShopExpenses.push({
                    description: shopDet.TR_DET,
                    amount: money(shopDet.TR_AMT),
                    isDisabled: true
                });
            });
        }

        return { AllShopData, ExtraShopExpenses, PayByAccountDetails, DeliveryDetails, fromDetails: shopData.dataFromDetail || [] };
    }

    async getAllExpense(SALEWEEK, SHOPID) {
        const result = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Finance/GetWeeklySaleExpense.php`, { SALEWEEK, SHOPID });
        return result.data;
    }

    getWeekShopPayment(SALEWEEK, SHOPID) {
        return axios.post(`${process.env.REACT_APP_BASE_URL}services/query/Finance/GetWeekShopPayment.php`, { SALEWEEK, SHOPID });
    }

    async handleOpenSale() {
        if (!this.ValidateSale()) return;
        this.props.toggleLoader(true);

        if (this.state.WS_ID === "") {
            const { WeeklyShop } = this.state;
            const returnData = await this.getAllShopExpense(this.state.SaleWeek, WeeklyShop.value);
            this.setState({
                ExtraShopExpenses: returnData.ExtraShopExpenses,
                payAccDetails: returnData.PayByAccountDetails,
                DeliveryDetails: returnData.DeliveryDetails,
                fromDetails: returnData.fromDetails
            });
        }

        const WS_PRO_LOS = money(this.returnProfitAndLoss());
        const formData = {
            WS_ID: this.state.WS_ID,
            SaleWeek: this.state.SaleWeek,
            WS_STATUS: "PENDING",
            WeeklyShop: this.state.WeeklyShop.value,
            WeekDays: JSON.stringify(this.state.WeekDays),
            LastUpdateBY: localStorage.getItem('PC_USR_NAME'),
            WS_PRO_LOS,
            PC_GRP_ID: this.state.PC_GRP_ID,
            PC_SHOP_ID: this.state.PC_SHOP_ID
        };

        try {
            const getSaleResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/Finance/PCAddWeeklySale.php`, formData);
            if (getSaleResult.data.status === 201) {
                Swal.fire('Success', getSaleResult.data.message, 'success').then(res => {
                    if (res.isConfirmed) {
                        if (this.state.WS_ID === "") {
                            this.setState({ WS_ID: getSaleResult.data.extra[0].PC_WS_ID });
                        }
                        this.setState({ isEdit: true, isShopDisable: true });
                    } else {
                        this.handleExit();
                    }
                });
            } else {
                Swal.fire('Error', getSaleResult.data.message, 'error');
            }
            this.props.toggleLoader(false);
        } catch (error) {
            console.error('handleOpenSale error:', error);
            this.props.toggleLoader(false);
        }
    }

    handleExit() {
        this.getWeeklySale();
        this.setState({
            isEdit: false,
            addWeekSale: false,
            WS_ID: "",
            SaleWeek: "",
            WeeklyShop: "",
            WeekDays: [],
            ExtraShopExpenses: []
        });
    }

    handleChangeWeekSale(index, evnt) {
        const WeekDays = [...this.state.WeekDays];
        WeekDays[index] = { ...WeekDays[index], [evnt.target.name]: evnt.target.value };
        this.setState({ WeekDays });
    }

    handleChangeExtraWeekSale(index, evnt) {
        const ExtraShopExpenses = [...this.state.ExtraShopExpenses];
        ExtraShopExpenses[index] = { ...ExtraShopExpenses[index], [evnt.target.name]: evnt.target.value };
        this.setState({ ExtraShopExpenses });
    }

    returnTotalCashSale() {
        return sumMoney(this.state.WeekDays, "Cash");
    }

    returnTotalCardSale() {
        return sumMoney(this.state.WeekDays, "Card");
    }

    returnTotalOtherSale() {
        return sumMoney(this.state.WeekDays, "Others");
    }

    retunTotalExtraAmount() {
        return sumMoney(this.state.ExtraShopExpenses, "amount");
    }

    returnProfitAndLoss() {
        return WeeklySale.weekProfit(this.state.WeekDays, this.state.ExtraShopExpenses);
    }

    /* The week's profit: takings minus every expense line. The ONE formula — the form calls it on
     * its own state, bulk approve calls it on loadWeekData()'s result — so a bulk approval posts
     * exactly the figure the form would have. Same sums the returnTotal*Sale() helpers make. */
    static weekProfit(WeekDays, ExtraShopExpenses) {
        const TotalSale = sumMoney(WeekDays, "Cash") + sumMoney(WeekDays, "Card") + sumMoney(WeekDays, "Others");
        return TotalSale - sumMoney(ExtraShopExpenses, "amount");
    }


    /* Bulk transition for the rows ticked in the list. Routed through the same shared

     * endpoint the per-record action uses (services/mutation/Approval/PCApproveFinance.php),

     * so the rules cannot drift between one record and fifty. Partial results are normal

     * and are reported per record by reportTransition(). */

    async handleBulkTransition(to, ids) {

        const confirm = await Swal.fire({

            title: `Update ${ids.length} weekly sale${ids.length === 1 ? '' : 's'}?`,

            text: to === 'APPROVED'
                ? `They will be approved, and each partner's share of the week's profit will be posted.`
                : `They will be marked ${to.toLowerCase()}.`,

            icon: 'question',

            showCancelButton: true,

            confirmButtonText: 'Yes',

            cancelButtonText: 'No'

        });

        if (!confirm.isConfirmed) return;

        if (to === 'APPROVED') return this.bulkApprove(ids);

        this.setState({ bulkBusy: true });

        const result = await runTransition(APPROVAL_MODULES.WEEKLY_SALE, to, ids);

        this.setState({ bulkBusy: false, selectedIds: [] });

        if (result && result.approved > 0) this.getWeeklySale();

    }

    /* Bulk APPROVE (2026-10-22). Approving a weekly sale also posts each partner's share of the
     * week's profit (linking/WeeklySale.php), so this does, per week, exactly what opening it and
     * pressing Approve does — in the safe order:
     *
     *   1. compute every week's profit FIRST, with the form's own loader and formula. A week whose
     *      data cannot be loaded is not approved at all, so nothing is ever approved without its
     *      shares;
     *   2. approve through the same shared endpoint as everything else — the server still decides
     *      who may approve, per record;
     *   3. post shares only for the weeks the server actually approved.
     *
     * Every week that is skipped or whose shares fail to post is listed by id, with the reason. */
    async bulkApprove(ids) {
        this.setState({ bulkBusy: true });
        this.props.toggleLoader(true);

        const rowsById = {};
        (this.state.WeekSaleList || []).forEach(r => { rowsById[String(r.PC_WS_ID)] = r; });

        // 1. compute — a few weeks at a time, each week's three requests in parallel
        const computed = {};
        const notLoaded = [];
        const queue = ids.map(String);
        const worker = async () => {
            while (queue.length) {
                const id = queue.shift();
                const row = rowsById[id];
                if (!row) { notLoaded.push({ id, reason: 'Not on this page — open its page and approve it there.' }); continue; }
                try {
                    const d = await this.loadWeekData(row);
                    computed[id] = {
                        row,
                        WS_Card: money(sumMoney(d.WeekDays, "Card")),
                        WS_PRO_LOS: money(WeeklySale.weekProfit(d.WeekDays, d.ExtraShopExpenses)),
                    };
                } catch (e) {
                    console.error('bulk approve: could not load week', id, e);
                    notLoaded.push({ id, reason: 'Its sales and expenses could not be loaded, so it was not approved.' });
                }
            }
        };
        await Promise.all([...Array(Math.min(5, queue.length || 1))].map(worker));

        // 2. approve only what was computed
        const toApprove = Object.keys(computed);
        let result = toApprove.length > 0
            ? await postTransition(APPROVAL_MODULES.WEEKLY_SALE, 'APPROVED', toApprove)
            : { success: 1, approved: 0, skipped: [], message: 'Nothing was approved.' };

        // 3. post shares for the weeks the server approved — one at a time
        const shareFailed = [];
        if (result) {
            const refused = new Set((result.skipped || []).map(x => String(x.id)));
            for (const id of toApprove.filter(x => !refused.has(x))) {
                const c = computed[id];
                try {
                    const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/linking/WeeklySale.php`, {
                        SALE_DATE: c.row.PC_WS_WEEK,
                        SHOP_ID: c.row.PC_WS_SHOPID,
                        WS_Card: c.WS_Card,
                        WS_PRO_LOS: c.WS_PRO_LOS,
                    });
                    if (!res || !res.data || res.data.success !== 1) throw new Error((res && res.data && res.data.message) || 'not posted');
                } catch (e) {
                    console.error('bulk approve: partner shares did not post for week', id, e);
                    shareFailed.push(`#${id} ${formatDisplayWeek(c.row.PC_WS_WEEK)} — ${c.row.SP_NAME || 'shop ' + c.row.PC_WS_SHOPID}`);
                }
            }
            result = { ...result, skipped: [...(result.skipped || []), ...notLoaded] };
            // The server only saw the weeks that loaded; count against everything that was ticked.
            if (notLoaded.length > 0) {
                result.message = `${Number(result.approved || 0)} of ${ids.length} weekly sale${ids.length === 1 ? '' : 's'} approved.`;
            }
        }

        // Loader off BEFORE any dialog — it is a z-index 10000 overlay.
        this.props.toggleLoader(false);
        await reportTransition(result);
        if (shareFailed.length > 0) {
            await Swal.fire({
                icon: 'warning',
                title: 'Approved, but some partner shares did not post',
                html: `These weeks are approved. Re-open each one and approve it again to retry the posting:<br/><br/>${shareFailed.join('<br/>')}`,
            });
        }

        this.setState({ bulkBusy: false, selectedIds: [] });
        if (result && result.approved > 0) this.getWeeklySale();
    }

    async handleSendForApproval(Status) {
        /* Routed through the SAME shared endpoint the bulk bar uses, with a list of one.
         *
         * This replaced services/mutation/Finance/PCRequestWeeklySale.php, which took the
         * caller's identity from the request body (PC_GRP_ID / PC_SHOP_ID) and gated on a
         * hardcoded "PC_GRP_ID == '2'". PCApproveFinance.php reads the role AND the owning shop
         * from the SIGNED token instead, so a caller can no longer claim to be an admin.
         *
         * Approving also posts the partner's share of the week's profit via
         * linking/WeeklySale.php, from returnProfitAndLoss(). Bulk approve (bulkApprove) does the
         * same per week, using the same loader (loadWeekData) and formula (weekProfit), so the
         * two cannot post different figures. Bulk approve was withheld until 2026-10-22 because
         * it had no way to compute the profit; it now computes it exactly as this form does. */
        this.props.toggleLoader(true);
        /* The loader is hidden by the callback, BEFORE the dialog opens — it is a z-index
         * 10000 overlay and would otherwise sit on top of the dialog, leaving it visible but
         * unclickable and the page permanently blocked. */
        const result = await runTransition(APPROVAL_MODULES.WEEKLY_SALE, Status, [this.state.WS_ID],
            () => this.props.toggleLoader(false));

        /* The partner share is posted ONLY after the status change actually succeeded.
         * Previously this ran first, so a refused approval (a shop user, or a record someone
         * else had already reopened) still posted the share. */
        if (result && result.approved > 0) {
            if (Status === 'APPROVED') {
                // Loader back on for the share posting only, and off again BEFORE any dialog.
                this.props.toggleLoader(true);
                try {
                    await axios.post(`${process.env.REACT_APP_BASE_URL}services/linking/WeeklySale.php`, {
                        SALE_DATE: this.state.SaleWeek,
                        SHOP_ID: this.state.WeeklyShop.value,
                        WS_Card: money(this.returnTotalCardSale()),
                        WS_PRO_LOS: money(this.returnProfitAndLoss()),
                    });
                    this.props.toggleLoader(false);
                } catch (error) {
                    this.props.toggleLoader(false);
                    console.error('weekly sale partner-share posting failed :>> ', error);
                    Swal.fire(
                        'Approved, but the partner share did not post',
                        'The week is approved. Re-open and approve it again to retry the posting.',
                        'warning'
                    );
                }
            }
            this.handleExit();
        }
    }

    handleDelete(PC_WS_ID) {
        Swal.fire({
            title: 'Do you want to delete weekly sale?',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.props.toggleLoader(true);
                const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/delete/finance/DeleteWeeklySale.php`, { PC_WS_ID, PC_GRP_ID: this.state.PC_GRP_ID, PC_SHOP_ID: this.state.PC_SHOP_ID });
                if (res.data.success === 1) {
                    Swal.fire('Weekly Sale Deleted!', '', 'success');
                    this.getWeeklySale();
                }
                this.props.toggleLoader(false);
            }
        });
    }

    handleBlurWeekSale(index, evt) {
        const WeekDays = [...this.state.WeekDays];
        WeekDays[index] = { ...WeekDays[index], [evt.target.name]: money(evt.target.value) };
        this.setState({ WeekDays });
    }

    handleBlurExtraWeekSale(index, evnt) {
        const ExtraShopExpenses = [...this.state.ExtraShopExpenses];
        ExtraShopExpenses[index] = { ...ExtraShopExpenses[index], [evnt.target.name]: money(evnt.target.value) };
        this.setState({ ExtraShopExpenses });
    }

    handleShowDetails(desc) {
        if (desc === "Pay By Account") this.setState({ showModal: true });
        else if (desc === "Delivery") this.setState({ showDelModal: true });
        else if (desc === "Account Payment (From)") this.setState({ showFromModal: true });
    }

    render() {
        const { addWeekSale, isEdit, WeekSaleList } = this.state;

        // Shop users (PC_GRP_ID 2) may only edit a sale while it is still PENDING; once it is
        // REQUESTED/APPROVED the form becomes read-only for them. Admins keep the old rule
        // (editable until APPROVED).
        const isShopUser = this.state.PC_GRP_ID === '2';
        const status = this.state.PC_WS_STATUS;
        // Reopen is offered only to SUPER_ADMIN, and only on a record that is not already pending.
        const canReopen = isSuperAdmin() && status !== "PENDING";
        const canEdit = isShopUser ? status === 'PENDING' : status !== 'APPROVED';

        if (!addWeekSale) {
            return (
                <Container>
                    <BulkActionBar
                        rows={WeekSaleList.filter(r => this.state.selectedIds.includes(String(r.PC_WS_ID)))}
                        statusField="PC_WS_STATUS"
                        idField="PC_WS_ID"
                        canApprove={this.state.canApprove}
                        busy={this.state.bulkBusy}
                        onAction={this.handleBulkTransition.bind(this)}
                        onClear={() => this.setState({ selectedIds: [] })}
                    />
                    <PhoneClinicGrid
                        selection={{
                            rowIds: WeekSaleList.map(r => String(r.PC_WS_ID)),
                            // Only rows with a transition available to this user can be ticked.
                            selectableIds: WeekSaleList
                                .filter(r => approvalActions(r.PC_WS_STATUS, this.state.canApprove).length > 0)
                                .map(r => String(r.PC_WS_ID)),
                            selected: this.state.selectedIds,
                            onChange: (ids) => this.setState({ selectedIds: ids }),
                        }}
                        ref={this.gridRef}
                        title="WEEKLY SALES"
                        buttonLabel="Week Sale"
                        isEditable={true}
                        onClickButton={this.hanldeAddWeekSale.bind(this)}
                        getData={this.getWeeklySale.bind(this)}
                        tableHeadData={[
                            { label: "WEEK", isHidden: false },
                            { label: "SHOP", isHidden: false },
                            { label: "CASH", isHidden: false },
                            { label: "CARD", isHidden: false },
                            { label: "OTHERS", isHidden: false },
                            { label: "CREATED BY", isHidden: false },
                            { label: "STATUS", isHidden: false },
                        ]}
                    >
                        {WeekSaleList.map((service, idx) => {
                            return (
                                <TableRow
                                    key={idx}
                                    /* The grid reads this to know which record a checkbox selects. */
                                    data-pcid={String(service.PC_WS_ID)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    <TableCell align='left'>{formatDisplayWeek(service.PC_WS_WEEK)}</TableCell>
                                    <TableCell align='left' style={{ cursor: 'pointer', color: "#416bc7" }}>{service.SP_NAME}</TableCell>
                                    <TableCell align='left'>{formatAmount(service.WS_Cash)}</TableCell>
                                    <TableCell align='left'>{formatAmount(service.WS_Card)}</TableCell>
                                    <TableCell align='left'>{formatAmount(service.WS_Other)}</TableCell>
                                    <TableCell align='left'>{service.PC_WS_BY}</TableCell>
                                    <TableCell align='left'>
                                        <StatusChip label={service.PC_WS_STATUS} />
                                    </TableCell>
                                    <TableCell align='center'>
                                        <RowActions actions={[
                                            { type: 'edit', onClick: this.handleUpdateSale.bind(this, service) },
                                            { type: 'delete', onClick: this.handleDelete.bind(this, service.PC_WS_ID), show: (!isShopUser || service.PC_WS_STATUS === "PENDING") },
                                        ]} />
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </PhoneClinicGrid>
                </Container>
            );
        }

        const weekDateRange = this.state.WeekDays.length > 0
            ? `${formatDisplayDate(this.state.WeekDays[0].DateAndDay)} — ${formatDisplayDate(this.state.WeekDays[6].DateAndDay)}`
            : '';
        const totalCash = money(this.returnTotalCashSale());
        const totalCard = money(this.returnTotalCardSale());
        const totalOther = money(this.returnTotalOtherSale());
        const totalSale = money(+totalCash + +totalCard + +totalOther);
        const totalExpenses = money(this.retunTotalExtraAmount());
        const profitLoss = money(this.returnProfitAndLoss());
        const isProfitable = parseFloat(profitLoss) >= 0;

        const MODAL_HEAD = { background: '#f1f1f1', color: '#111827' };

        return (
            <Container fluid style={{ padding: '8px 16px' }}>
                <PageHeader title={this.state.isEdit ? 'Edit Weekly Sale' : 'Add Weekly Sale'}
                    mode={this.state.isEdit ? 'edit' : 'new'}
                    subtitle={weekDateRange ? `Period: ${weekDateRange}` : undefined} />
                {/* ── Header card ─────────────────────────────────────── */}
                <div style={CARD}>
                    <div style={{ padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 16, borderBottom: '1px solid #f1f5f9' }}>
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
                            <div>
                                <label style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#64748b', display: 'block', marginBottom: 4 }}>
                                    Week
                                </label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    /* Locked only on a saved record. A shop user's SHOP is fixed, but they pick the week
                                       like an admin (the server refuses a second record for the same shop + week). */
                                    disabled={this.state.isEdit}
                                    value={this.state.SaleWeek}
                                    onChange={this.handleChange.bind(this, "SaleWeek")}
                                    style={{ width: 220 }}
                                />
                            </div>
                            <div>
                                <label style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#64748b', display: 'block', marginBottom: 4 }}>
                                    Shop Location
                                </label>
                                <div style={{ width: 260 }}>
                                    <Select menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        isDisabled={this.state.isShopDisable}
                                        value={this.state.WeeklyShop}
                                        options={this.state.ShopList}
                                        onChange={this.handleChange.bind(this, "WeeklyShop")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Daily Breakdown + Expenses ───────────────────────── */}
                {isEdit && (
                    <Row style={{ marginBottom: 24 }}>
                        {/* Daily Breakdown (7 cols) */}
                        <Col md={7}>
                            <div style={CARD}>
                                <div style={{ padding: '14px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 600, fontSize: 15, color: '#334155' }}>Daily Breakdown</span>
                                    <span style={{ fontSize: 12, padding: '2px 8px', background: '#f1f3ff', color: '#3b82f6', borderRadius: 6, fontWeight: 500 }}>
                                        Auto-calculating
                                    </span>
                                </div>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ background: '#f8fafc' }}>
                                                <TableCell style={COL_HEAD}>Day / Date</TableCell>
                                                <TableCell style={COL_HEAD}>Cash</TableCell>
                                                <TableCell style={COL_HEAD}>Card</TableCell>
                                                <TableCell style={COL_HEAD}>Others</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.WeekDays.map((service, idx) => (
                                                <TableRow key={idx} sx={{ '&:hover': { background: '#f8faff' } }}>
                                                    <TableCell style={{ fontSize: 13, fontWeight: 500, color: '#475569', whiteSpace: 'nowrap', padding: '8px 16px' }}>
                                                        {formatDisplayDate(service.DateAndDay)}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '5px 12px' }}>
                                                        <AmountInput
                                                            name="Cash"
                                                            style={INPUT}
                                                            disabled={!canEdit}
                                                            onBlur={this.handleBlurWeekSale.bind(this, idx)}
                                                            value={service.Cash}
                                                            onChange={this.handleChangeWeekSale.bind(this, idx)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '5px 12px' }}>
                                                        <AmountInput
                                                            name="Card"
                                                            style={INPUT}
                                                            disabled={!canEdit}
                                                            onBlur={this.handleBlurWeekSale.bind(this, idx)}
                                                            value={service.Card}
                                                            onChange={this.handleChangeWeekSale.bind(this, idx)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '5px 12px' }}>
                                                        <AmountInput
                                                            name="Others"
                                                            style={INPUT}
                                                            disabled={!canEdit}
                                                            onBlur={this.handleBlurWeekSale.bind(this, idx)}
                                                            value={service.Others}
                                                            onChange={this.handleChangeWeekSale.bind(this, idx)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow sx={{ background: '#f8fafc', borderTop: '2px solid #e2e8f0' }}>
                                                <TableCell style={{ fontWeight: 700, fontSize: 13, color: '#334155', padding: '10px 16px' }}>TOTAL</TableCell>
                                                <TableCell style={{ fontWeight: 700, fontSize: 13, color: '#334155', padding: '10px 12px' }}>{formatAmount(totalCash)}</TableCell>
                                                <TableCell style={{ fontWeight: 700, fontSize: 13, color: '#334155', padding: '10px 12px' }}>{formatAmount(totalCard)}</TableCell>
                                                <TableCell style={{ fontWeight: 700, fontSize: 13, color: '#334155', padding: '10px 12px' }}>{formatAmount(totalOther)}</TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Col>

                        {/* Weekly Expenses (5 cols) */}
                        <Col md={5}>
                            <div style={{ ...CARD, display: 'flex', flexDirection: 'column' }}>
                                <div style={{ padding: '14px 20px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {/* Expense lines come only from their sources (charges, delivery, account
                                        and shop payments). Manually added rows were removed on 2026-10-22 at the
                                        user's request; they were never saved as lines, only folded into the profit. */}
                                    <span style={{ fontWeight: 600, fontSize: 15, color: '#334155' }}>Weekly Expenses</span>
                                </div>
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ background: '#f8fafc' }}>
                                                <TableCell style={{ ...COL_HEAD, width: 36, textAlign: 'center' }}>#</TableCell>
                                                <TableCell style={COL_HEAD}>Description</TableCell>
                                                <TableCell style={{ ...COL_HEAD, textAlign: 'right' }}>Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.ExtraShopExpenses.map((service, idx) => (
                                                <TableRow key={idx} sx={{ '&:hover': { background: '#f8faff' } }}>
                                                    <TableCell
                                                        style={{ fontSize: 12, color: '#94a3b8', textAlign: 'center', padding: '5px 8px', cursor: service.description === "Pay By Account" || service.description === "Delivery" || service.description === "Account Payment (From)" ? 'pointer' : 'default' }}
                                                        onClick={this.handleShowDetails.bind(this, service.description)}
                                                    >
                                                        {idx + 1}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '4px 12px' }}>
                                                        <Form.Control
                                                            name="description"
                                                            style={INPUT}
                                                            disabled={service.isDisabled || !canEdit}
                                                            value={service.description}
                                                            onChange={this.handleChangeExtraWeekSale.bind(this, idx)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '4px 12px' }}>
                                                        <AmountInput
                                                            name="amount"
                                                            style={{ ...INPUT, textAlign: 'right' }}
                                                            disabled={service.isDisabled || !canEdit}
                                                            value={service.amount}
                                                            onBlur={this.handleBlurExtraWeekSale.bind(this, idx)}
                                                            onChange={this.handleChangeExtraWeekSale.bind(this, idx)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow sx={{ background: '#f8fafc', borderTop: '2px solid #e2e8f0' }}>
                                                <TableCell colSpan={2} style={{ fontWeight: 700, fontSize: 13, color: '#334155', padding: '10px 12px' }}>TOTAL EXPENSES</TableCell>
                                                <TableCell style={{ fontWeight: 700, fontSize: 13, color: '#334155', textAlign: 'right', padding: '10px 12px' }}>{formatAmount(totalExpenses)}</TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Col>
                    </Row>
                )}

                {/* ── Footer: stat cards + action buttons ─────────────── */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 20, marginBottom: 24 }}>
                    {isEdit ? (
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                            <div style={{ background: '#f1f3ff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '14px 20px', minWidth: 160 }}>
                                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#a32f2f' }}>Total Weekly Sale</div>
                                <div style={{ fontSize: 28, fontWeight: 700, color: '#a32f2f', marginTop: 4 }}>{formatAmount(totalSale)}</div>
                            </div>
                            <div style={{
                                background: isProfitable ? '#f0fdf4' : '#fff1f2',
                                border: `1px solid ${isProfitable ? '#bbf7d0' : '#fecdd3'}`,
                                borderRadius: 12,
                                padding: '14px 20px',
                                minWidth: 160
                            }}>
                                <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', color: isProfitable ? '#16a34a' : '#dc2626' }}>Profit / Loss</div>
                                <div style={{ fontSize: 28, fontWeight: 700, color: isProfitable ? '#16a34a' : '#dc2626', marginTop: 4 }}>
                                    {isProfitable ? '+' : ''}{formatAmount(profitLoss)}
                                </div>
                            </div>
                        </div>
                    ) : <div />}

                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                        <Button
                            variant="outlined"
                            onClick={this.handleExit.bind(this)}
                            style={{ borderColor: '#cbd5e1', color: '#475569', textTransform: 'none', fontWeight: 600 }}
                        >
                            Cancel
                        </Button>
                        {canEdit && (
                            <Button
                                variant="contained"
                                onClick={this.handleOpenSale.bind(this)}
                                style={{ background: '#1e293b', textTransform: 'none', fontWeight: 600 }}
                            >
                                {isEdit ? 'Update Sale' : 'Open Sale'}
                            </Button>
                        )}
                        {/* Shop users can only send for approval (PENDING → REQUESTED); admins can also approve. */}
                        {isEdit && (isShopUser ? status === "PENDING" : status !== "APPROVED") && (
                            <Button
                                variant="contained"
                                onClick={this.handleSendForApproval.bind(this, status === "PENDING" ? "REQUESTED" : "APPROVED")}
                                style={{ background: '#a32f2f', textTransform: 'none', fontWeight: 600 }}
                            >
                                {status === "PENDING" ? "Send For Approval" : "Approve"}
                            </Button>
                        )}
                        {/* Reopen, inside the form (added 2026-10-13 on the user's request).
                            SUPER_ADMIN only, and hardcoded as such — the same rule as the edit
                            override in helper/Approval.php. The server re-checks APPROVE from the
                            signed token, so hiding the button is an affordance, not the control.

                            Safe to re-approve afterwards: linking/WeeklySale.php posts the partner
                            share with UPDATE-if-exists / INSERT-otherwise on (TR_WEEK, ACC_ID,
                            TR_TYPE='1'), so the share is recomputed from the edited figures rather
                            than posted twice. */}
                        {isEdit && canReopen && (
                            <Button
                                variant="outlined"
                                onClick={this.handleSendForApproval.bind(this, "PENDING")}
                                style={{ borderColor: '#a32f2f', color: '#a32f2f', textTransform: 'none', fontWeight: 600 }}
                            >
                                Reopen to Edit
                            </Button>
                        )}
                    </div>
                </div>

                {/* ── Pay By Account detail modal ──────────────────────── */}
                <Modal show={this.state.showModal} onHide={() => this.setState({ showModal: false })} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Pay Account Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={MODAL_HEAD}>Sr.No</TableCell>
                                        <TableCell style={MODAL_HEAD}>From</TableCell>
                                        <TableCell style={MODAL_HEAD}>Week</TableCell>
                                        <TableCell style={MODAL_HEAD}>Description</TableCell>
                                        <TableCell style={MODAL_HEAD}>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.payAccDetails.map((payAccDet, idx) => (
                                        <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>{idx + 1}</TableCell>
                                            <TableCell>{payAccDet.ACCOUNT_TITLE}</TableCell>
                                            <TableCell>{payAccDet.TR_WEEK}</TableCell>
                                            <TableCell>{payAccDet.TR_DET}</TableCell>
                                            <TableCell>{formatAmount(payAccDet.TR_AMT)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showModal: false })}>Close</Button>
                    </Modal.Footer>
                </Modal>

                {/* ── Weekly Delivery detail modal ─────────────────────── */}
                <Modal show={this.state.showDelModal} onHide={() => this.setState({ showDelModal: false })} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Weekly Delivery Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TableContainer>
                            <Table size='medium'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={MODAL_HEAD}>Sr.No</TableCell>
                                        <TableCell style={MODAL_HEAD}>From</TableCell>
                                        <TableCell style={MODAL_HEAD}>Week</TableCell>
                                        <TableCell style={MODAL_HEAD}>Date</TableCell>
                                        <TableCell style={MODAL_HEAD}>Description</TableCell>
                                        <TableCell style={MODAL_HEAD}>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.DeliveryDetails.map((payAccDet, idx) => (
                                        <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>{idx + 1}</TableCell>
                                            <TableCell>{payAccDet.BD_TO}</TableCell>
                                            <TableCell>{payAccDet.BD_WEEK}</TableCell>
                                            <TableCell>{formatDisplayDate(payAccDet.BD_DATE)}</TableCell>
                                            <TableCell>{payAccDet.BD_DESC}</TableCell>
                                            <TableCell>{formatAmount(payAccDet.BD_AMT)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showDelModal: false })}>Close</Button>
                    </Modal.Footer>
                </Modal>

                {/* ── Account Payment (From) detail modal ───────────────── */}
                <Modal show={this.state.showFromModal} onHide={() => this.setState({ showFromModal: false })} size='lg'>
                    <Modal.Header closeButton>
                        <Modal.Title>Account Payment (From) Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TableContainer>
                            <Table size='medium'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={MODAL_HEAD}>Sr.No</TableCell>
                                        <TableCell style={MODAL_HEAD}>Account</TableCell>
                                        <TableCell style={MODAL_HEAD}>Week</TableCell>
                                        <TableCell style={MODAL_HEAD}>Date</TableCell>
                                        <TableCell style={MODAL_HEAD}>Description</TableCell>
                                        <TableCell style={MODAL_HEAD}>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.fromDetails.map((fromDet, idx) => (
                                        <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>{idx + 1}</TableCell>
                                            <TableCell>{fromDet.ACCOUNT_TITLE || fromDet.ACC_ID}</TableCell>
                                            <TableCell>{fromDet.TR_WEEK}</TableCell>
                                            <TableCell>{formatDisplayDate(fromDet.TR_DATE)}</TableCell>
                                            <TableCell>{fromDet.TR_DET}</TableCell>
                                            <TableCell>{formatAmount(fromDet.TR_AMT)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showFromModal: false })}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}
